import { combineReducers } from "redux";
import user from "../user";
import leaderboard from "../leaderboard";
import address from "../address";
import prizeTier from "../prizeTier";
import checkout from "../checkout";
import progressBar from "../progressBar";
import qwizme from "../qwizme";
import trials from "../trials";
import incentives from "../incentives";
import rewards from "../rewards";
import campaigns from "../campaigns";
import cart_item from "../cart_items";
import testimonials from "../testimonials";
import inquiries from "../inquiries";
import captcha_validator from "../captcha_validator";
import recent_samples from "../recent_samples";
import landing from "../landing";

export default combineReducers({
  user,
  address,
  prizeTier,
  checkout,
  leaderboard,
  progressBar,
  qwizme,
  trials,
  incentives,
  rewards,
  campaigns,
  cart_item,
  testimonials,
  inquiries,
  captcha_validator,
  recent_samples,
  landing
});
